import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g color="#000" fill="#474747"><path d="M9.51.044c-1.273 0-2.307.973-2.448 2.218-.324-.122-.657-.218-1.023-.218-1.643 0-2.975 1.343-2.975 3 0 .098.022.186.031.281a1.982 1.982 0 00-1.022-.281 1.992 1.992 0 00-1.984 2C.09 8.15.905 9 2 9h5V7.5c-.016-.786.74-1.47 1.518-1.487.8-.017 1.499.68 1.482 1.487V9h4.5c.822 0 1.455-.627 1.455-1.456 0-.828-.666-1.5-1.487-1.5-.206 0-.411.05-.59.125a2.44 2.44 0 00.094-.625c0-1.23-.886-2.228-2.046-2.438.042-.181.062-.368.062-.562a2.49 2.49 0 00-2.479-2.5z" style={{
        marker: "none"
      }} overflow="visible" /><path d="M8.492 6.994A.5.5 0 008 7.5V10H5v1H3.293L.647 13.646a.5.5 0 10.707.708L3.707 12H5v3a.5.5 0 101 0v-3.424a.5.5 0 000-.152V11h2v.707l2 2V15a.5.5 0 101 0v-1h1.362l2.38 1.428a.5.5 0 10.516-.856L12.638 13h-1.93L9 11.293v-.717a.5.5 0 000-.152V7.5a.5.5 0 00-.508-.506z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} fontWeight={400} fontFamily="sans-serif" overflow="visible" /></g></svg>;
}

export default SvgComponent;